import { Vue, Options } from 'vue-class-component';

@Options({
  name: 'ButtonSelection',
  props: {
    modelValue: {
      type: Boolean,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
      required: true,
    },
    icon: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
  },
  emits: ['update:modelValue'],
})
export default class ToggleSwitchButton extends Vue {
  modelValue?: boolean;
  disabled?: boolean;
  icon !: string;
  label !: string;

  get localValue (){
    return this.modelValue ?? false
  }
  set localValue (value: boolean){
    if (this.disabled) return;
    this.$emit('update:modelValue', value);
  }

  toggleValue() {
    this.localValue = !this.localValue;
  }
}
